import React, { useEffect, useState } from "react"
import Webnav from "../components/Webnav"
import { Box, Grid } from "@mui/material"
import { Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import apiClient from "../api/apiClient"
import { useDispatch, useSelector } from "react-redux"
import { showModal } from "../redux/modalSlice"
import { Modal } from "react-bootstrap"
import { copyRightYear } from "../modules/helpers"
import PublicBarcodeForm from "../components/public/PublicBarcodeForm"
import "../components/public/PublicA11y.css"

function Home() {
  const [barcode, setBarcode] = useState()
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const handleNumericInput = e => {
    const numericInput = e.target.value
    setBarcode(numericInput)
  }

  const navigate = useNavigate()
  const { isLoggedIn, userType } = useSelector(state => state.auth)
  useEffect(() => {
    if (isLoggedIn) navigate(userType === "AD" ? "/admin/dashboard" : "/tn/dashboard")
  }, [isLoggedIn, navigate, userType])
  async function handleNavigateClient() {
    const result = await apiClient.post(`/client/?validate=true`, { barcode })
    if (!result.ok)
      return dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    navigate("/petbio-registration/" + barcode)
  }

  useEffect(() => {
    setShow(true)
  }, [])
  return (
    <div className="public-a11y-page">
      <a className="public-skip-link" href="#main-content">
        Skip to main content
      </a>
      <Webnav />
      <InfoModal show={show} onHide={() => setShow(false)} />

      <Grid
        component="main"
        id="main-content"
        container
        spacing={0}
        sx={{
          alignItems: "stretch",
          minHeight: { md: "calc(100dvh - 76px)" },
          pt: "76px"
        }}
      >
        <Grid
          className=" "
          item
          xs={12}
          md={5}
          sx={{
            backgroundColor: "#FFFFFF",
            color: "#716879",
            padding: { xs: "2rem", md: "3rem" },
            display: "flex",
            alignItems: "",
            justifyContent: "center",
            minHeight: { md: "calc(100dvh - 76px)" }
          }}
        >
          <Box sx={{ maxWidth: 620 }}>
            {/* <Typography className='nova_font_bold text-uppercase' variant="h4" align="left">
      Welcome to a world where <br /> your pet's Intolerances are <br /> taken seriously
    </Typography> */}
            {/* <Typography className='nova_font_normal' component="p" align="left" sx={{ marginTop: '1rem', marginBottom: '1rem' }}>
      Simply click "register my test" to fill out all of your pets info. Be sure to add your barcode number that can be found on the card in your box. Once you have registered your test and sent in your samples, please give us up to 7 business days to send your results. You will receive an email as soon as your samples arrive at our biofeedback center. Once your results are in, you will receive an email with your results and our suggestions on solutions. We are so happy you are here and taking this step in finding out what your pet is trying to tell you.
    </Typography> */}
            {/* <p>
             To get started,
              </p> 
              
            <Typography
              className="nova_font_normal "
              component="p"
              align="left"
              sx={{ marginTop: "1rem", marginBottom: "1rem" }}
            >
            
               simply click on the "Register My Test" button and
              fill out all of your pet's information. 
              Don't forget to include the barcode number which you can find on the card inside your box.
            </Typography>

            <Typography
              className="nova_font_normal "
              component="p"
              align="left"
              sx={{ marginTop: "1rem", marginBottom: "1rem" }}
            >
              After registering, please send in your pet's samples.
              After registering, please send in your pet's samples. 
              As soon as they arrive at our biofeedback centre. */}
            {/* As soon as
              they arrive at our biofeedback centre, you will receive an email
              notification. */}
            {/* </Typography> */}
            {/* <Typography
              className="nova_font_normal "
              component="p"
              align="left"
              sx={{ marginTop: "1rem", marginBottom: "1rem" }}
            >
              Please be patient and allow up to 5 to 7 business days to receive your
              results via email. This email will guide you through understanding
              the results and direct you to receive product recommendations from
              our knowledgeable team members.
            </Typography>
            <Typography
              className="nova_font_normal "
              component="p"
              align="left"
              sx={{ marginTop: "1rem", marginBottom: "1rem" }}
            >
              We are so happy you are here and taking this step towards finding
              out what your pet is trying to tell you.
            </Typography> */}

            <Typography component="h1" variant="h4" sx={{ color: "#3E4755", fontWeight: 800, mb: 2 }}>
              TO GET STARTED:
            </Typography>

            <p className="my-3"> 1. Find your barcode number on the card inside your box.</p>
            <p className="my-3">
              {" "}
              2. Click on "Enter Your Code" and add your specific barcode number.{" "}
            </p>
            <p className="my-3">
              {" "}
              3. Click on the "Register My Test" button and fill out your pet's information.{" "}
            </p>

            <p>
              {" "}
              After registering, please return your pet's samples in the self-addressed prepaid
              shipping bag.{" "}
              <span className="fw-bold"> International tests: please see below. </span> As soon as
              they arrive at our biofeedback center, we will send you an email with a confirmation
              of receipt. Please be patient and allow 7–10 business days to receive your results via
              email after we have received them. This email will guide you through understanding the
              results and direct you to receive product recommendations from our knowledgeable team
              members. If you have any questions or concerns about the process, please don't
              hesitate to reach out to our customer support team. They are available to assist you
              and provide any necessary guidance throughout the entire testing process.
            </p>

            <p className="mb-5 ">
              We value your trust in our services and look forward to helping you gain valuable
              insights into your pet's health and wellness.
            </p>

            <h2 className="h6 mb-3 text-decoration-underline">International:</h2>
            <p>Using Post Mail, send to:</p>

            <p>PO Box 6765, Round Rock, TX 78683, USA</p>
            <p className="m-0">Using FedEx, UPS, or DHL, send to:</p>
            <p className="m-0">2250 Double Creek Dr., #6765, Round Rock, TX 78664, USA </p>

            <PublicBarcodeForm
              barcode={barcode}
              onBarcodeChange={handleNumericInput}
              onSubmit={handleNavigateClient}
            />
          </Box>
        </Grid>

        <Grid className="" item xs={12} md={7}>
          <Box
            sx={{
              alignItems: "center",
              backgroundColor: "#f7f8fb",
              display: "flex",
              height: { xs: "auto", md: "calc(100dvh - 76px)" },
              justifyContent: "center",
              overflow: "hidden",
              // position: { md: "sticky" },
              top: { md: 76 }
            }}
          >
            <Box
              component="img"
              src={require("../assets/Main-Poster.png")}
              alt="Glacier Peak Holistics pet intolerance test registration poster"
              sx={{
                display: "block",
                height: { xs: "auto", md: "100%" },
                maxHeight: { xs: "none", md: "calc(100dvh - 76px)" },
                objectFit: "contain",
                width: "100%"
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          backgroundColor: "#3E4755",
          height: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 1rem",
          "@media (max-width: 600px)": {
            height: "auto"
          }
        }}
      >
        <Typography className="nova_font_bold" variant="h4" color="white" align="center">
          GLACIER PEAK HOLISTICS <br /> TEST REGISTRATION
        </Typography>
      </Box>
      <Box
        component="footer"
        className="shadow"
        sx={{
          backgroundColor: "#3E4755",
          padding: "1rem",
          textAlign: "center",
          color: "white"
        }}
      >
        <p className="text-center text-white mb-4" style={{ backgroundColor: "#3E4755" }}>
          &copy;{copyRightYear()} GLACIER PEAK HOLISTICS TEST REGISTRATION All Rights Reserved.
        </p>


      </Box>
    </div>
  )
}
export default Home

function InfoModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      dialogClassName="public-info-modal-dialog"
      aria-labelledby="sample-info-modal-title"
      aria-describedby="sample-info-modal-body"
      centered
    >
      <Modal.Header className=" " closeButton closeLabel="Close sample gathering information">
        <Modal.Title id="sample-info-modal-title" className="text-center w-100">
          INFORMATION
        </Modal.Title>
      </Modal.Header>
      <Modal.Body id="sample-info-modal-body">
        <div>
          <h2>HOW TO GATHER SAMPLES:</h2>
          <ol>
            <li>Carefully remove the swabs from the biohazard bag, only touching one end.</li>
            <li>Swab your pet's mouth using all three at once or one at a time.</li>
            <li>Carefully put them back in the biohazard bag with the wet end at the bottom.</li>
            <li>
              Add hair sample to bag with swabs.
              <ul>
                <li>
                  Options to collect hair: (The size of a quarter will do)
                  <ul>
                    <li>
                      Use a clean, unused brush or comb (it’s important that the hair should not be
                      contaminated by any other pet or human).
                    </li>
                    <li>Gently pull out a small amount of shedding hair.</li>
                    <li>Cut hair from the rump area.</li>
                    <li>
                      For hairless pets, make sure to get the swabs very wet with the saliva from
                      your pet's mouth. We can still run the test this way.
                    </li>
                    <li>
                      Put the hair in the biohazard bag with the swabs and close it using the zip
                      closure on the end.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              Place it in the bag with the return label already attached, and drop it off at your
              nearest post office.
            </li>
            <li>
              <h3 className="h6">FOR INTERNATIONAL RETURNS:</h3>
              <ul style={{ listStyle: "lower-alpha" }}>
                <li>Follow the same procedure as above to collect your samples.</li>
                <li>Post Mail: PO Box 6765, Round Rock, TX 78683.</li>
              </ul>
            </li>
            <li>
              If using FedEx, UPS, or DHL, please ship to the physical address:
              <ul>
                <li style={{ listStyle: "lower-alpha" }}>
                  2250 Double Creek Dr, c/o Box 6765, Round Rock, TX 78664, USA.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </Modal.Body>
    </Modal>
  )
}
